export function extractTenantId(xId?: string | null): string | null {
  if (!xId) {
    return null;
  }

  const value = String(xId).trim();
  if (!value) {
    return null;
  }

  const match = value.match(/^(.*)_([0-9]+)$/);
  if (!match) {
    return value;
  }

  const prefix = match[1];
  if (isGuid(prefix)) {
    return prefix;
  }

  return value;
}

function isGuid(value: string): boolean {
  return /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(
    value,
  );
}
